module.exports = __webpack_public_path__ + "media/application/images/ui/tick-peoples-choice-427a23b19ee1372f84f9b9c0a68090e9.svg";